import { StyleSheet, useWindowDimensions, View } from 'react-native';
import { useStoreState } from '@/stores/store';
import { ProgressCharts } from '@/components/CustomWebView/ProgressCharts';
import { useDialogBridge } from '@/hooks/useDialogBridge';

interface StarsChartsProps {
  isVisible: boolean;
  onConfirm: (value: boolean) => void;
}

export const StarsCharts = ({ isVisible, onConfirm }: StarsChartsProps) => {
  const signedInUser = useStoreState((state) => state.signedInUser);
  const { height } = useWindowDimensions();
  const chartHeight = Math.round(height * 0.5);

  useDialogBridge(
    isVisible,
    () => ({
      contentComponent: () => (
        <View style={[styles.chartBox, { height: chartHeight }]}>
          <ProgressCharts patientId={signedInUser?.user?._id} />
        </View>
      ),
      wide: true,
      confirmAction: {
        label: 'weiter',
        onPress: () => onConfirm(false),
      },
    }),
    [signedInUser?.user?._id, chartHeight],
  );

  return null;
};

const styles = StyleSheet.create({
  chartBox: {
    width: '100%',
  },
});
